import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController, Platform } from '@ionic/angular';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { HttpService } from 'src/app/_provider/http.service';
import { SignPage } from '../sign.page';
import { PDFGenerator, PDFGeneratorOptions } from "@awesome-cordova-plugins/pdf-generator"
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { TicketZeit } from 'src/app/_interfaces/TicketTime';

import { ZeitenService } from 'src/app/_provider/zeiten.service';
import { timeIntervalDifference } from 'src/app/_pipes/timeDifference.Pipe';

import dayjs from '../../../_utils/dayjs.config';
import { WorkstepContent } from 'src/app/_template/ticket-detail/workstep-content/workstep-content.component';
import { SafeHtmlPipe } from 'src/app/_pipes/SafeHtml.Pipe';
import { CrmService } from 'src/app/_provider/crm.service';
import { Address } from 'src/app/_interfaces/address';
import { Attachment, AttachmentFile } from 'src/app/_interfaces/Attachment';
import { AnsprechpartnerPopoverPage } from 'src/app/_template/popover/ansprechpartner-popover/ansprechpartner-popover.page';
import { FilesService } from 'src/app/_provider/files.service';
import { EditArt } from 'src/app/_interfaces/EditArt';

@Component({
    selector: 'app-sign-preview',
    templateUrl: './sign-preview.page.html',
    styleUrls: ['./sign-preview.page.scss'],
    standalone: false
})
export class SignPreviewPage implements OnInit {

  @ViewChild(IonContent, {static: false}) ionContent: IonContent
  public html: string = ""
  public hasSigned: boolean = false
  public isMobile: boolean = true

  constructor(
    public platform: Platform,
    private http: HttpService,
    private feedback: FeedbackService,
    private modalCtrl: ModalController,
    private ticketSrv: TicketEmployee.TicketService,
    private timeIntervalDifference: timeIntervalDifference,
    private changeDetector: ChangeDetectorRef,
    private safeHtml: SafeHtmlPipe,
    private crmSrv: CrmService,
    private fileSrv: FilesService
  ) { 
    this.isMobile = this.platform.is("capacitor");
  }

  async ngOnInit() {
    await this.feedback.updateLoading("Erstellen...")
    const result: HttpFunctionResult<{html: string}> = await this.http.GET<{html: string}>({path: "ticketreport"})

    await this.feedback.hideLoading()
    this.html = result.data.html
    this.changeDetector.detectChanges()
    this.fillHtml()
    await this.feedback.openPopover<string>(AnsprechpartnerPopoverPage, null, {
      addressId: this.ticketSrv.ticket.address.managerId,
      type: "popover",
      searchMode: false,
    }, async (result: HttpFunctionResult<string>)=>{
      if(!result.success || result.data == null) {
        await this.feedback.hideKeyboardOnIOS()
        await this.close()
        return
      }
      document.getElementById("tb-customername-sign").innerText = result.data
    }, false)
  } 

  public async close(){
    await this.modalCtrl.dismiss()
  }

  public async setSign(){

    const result: HttpFunctionResult<string> = await this.feedback.showModal<string>({
      component: SignPage,
      cssClass: "modal-fullscreen"
    })

    if(!result.success) return
    
    const style = "width: auto; height: 100%"

    document.getElementById("sign").innerHTML = `<img style="${style}" src="${result.data}" />`
     
    await this.ionContent.scrollToBottom()
    this.hasSigned = true

  }

  private async fillHtml(){

    //Adresse
    const addressResult: HttpFunctionResult<Address> = await this.crmSrv.getSingleAddress(this.ticketSrv.ticket.address.managerId)
    if(!addressResult.success) return
    const addressData: Address = addressResult.data
    const companyName: string = addressData.companyOne ? addressData.companyOne : addressData.companyTwo ? addressData.companyTwo : ""
    document.getElementById("tb-customername").innerText = companyName == "" ? `${addressData.salutation} ${addressData.firstName} ${addressData.lastName}` : ""
    document.getElementById("tb-companyname").innerText =  companyName
    document.getElementById("tb-companystreet").innerText = addressData.street
    document.getElementById("tb-ziptown").innerText = `${addressData.plz} ${addressData.town}`
    

    //Ticketbezeichnung
    document.getElementById("tb-ticketdescription").innerText = this.ticketSrv.ticket.description

    //Ticketnummer
    document.getElementById("tb-ticketnumber").innerText = this.ticketSrv.ticket.number

    //Datum 
    document.getElementById("tb-date").innerText = dayjs().format("DD.MM.YYYY")

    //Ticketzeiten
    let times = document.getElementById("tb-times")
    let totaltime = document.getElementById("tb-totaltime")
    let timeHtml = ""
    let timeMinutes: number = 0


    let timeGroups: EditArt[] = []

    this.ticketSrv.ticket.times.forEach((time: TicketZeit, index: number)=>{
      timeMinutes += this.timeIntervalDifference.transform(time, null) as number
      let group: EditArt= timeGroups.find((tg)=>tg.id == time.taskId)
      if(!group) timeGroups.push({
        id: time.taskId,
        description: time.taskId == 0 ? "Ticketzeit" : this.ticketSrv.tasks.find(t=> t.id == time.taskId).description
      })
    })

    timeGroups.forEach((group: EditArt, index: number)=>{
      let minutes = this.ticketSrv.ticket.times.filter(t => t.taskId == group.id).map(t => this.timeIntervalDifference.transform(t, null) as number).reduce((a, b)=>a+b, 0)

      timeHtml += `
      <tr>
         <td>${index + 1}</td>
         <td>${group.description}</td>
         <td>${this.formatMinutesToString(minutes)}</td>
       </tr>
      `
    })


    times.innerHTML = timeHtml
    totaltime.innerText = this.formatMinutesToString(timeMinutes)

    //Artikel
    let articleHtml: string = ""
    this.ticketSrv.ticket.attachments
    .filter((a: Attachment)=>a.type == "Artikel" && a.toCalculate && a.workstepId == this.ticketSrv.activeWorkstepId)
    .forEach((a: Attachment, index: number)=>{
      if(a.type == "Artikel") articleHtml += `
      <tr>
          <td>${index + 1}</td>
          <td>${a.description}</td>
          <td>${a.quantity}</td>
      </tr>
      `
    })
    if(articleHtml) document.getElementById("tb-articles").innerHTML = articleHtml
    else document.getElementById("tb-article-sec").remove()
    


    //Einträge
    let contentHtml: string = ""
    this.ticketSrv.workstepContent.filter((content: WorkstepContent) => !content.isMail && content.art.id == 3).forEach((content: WorkstepContent)=>{
      contentHtml += `
      <div class="message-item">
          <h4>${content.userText}</h4>
          <div class="message-item-body">
            ${content.htmlText.replace("<p></p>", "")}
          </div>
      </div>
      `
    })
    if(contentHtml) document.getElementById("tb-messages").innerHTML = contentHtml //this.safeHtml.transform(contentHtml, false).toString()
    else document.getElementById("tb-messages-label").remove()
    
  } 

  /**
   * formatiert minuten zu einem String aus Stunden, Minuten uns sekunden
   * @param {number} timeMinutes Minuten Sie formatiert werden sollen
   * @returns {string}.
   */
  private formatMinutesToString(timeMinutes: number): string{
    const timeHours: number = Math.floor(dayjs.duration(timeMinutes, "minute").asHours())
    const timeHourString: string = `${timeHours < 10 ? "0": ""}${timeHours}`  
    const timeMinutesAndSeconds: string = dayjs.utc(dayjs.duration(timeMinutes, "minute").asMilliseconds()).format("mm:ss")
    return `${timeHourString}:${timeMinutesAndSeconds} Std.`
  }

  public async shareTicketReport(){
    const options: PDFGeneratorOptions = {
      documentSize: "A4",
      type: "share",
      fileName: `ticketbericht_${dayjs().format("DD_MM_YYYY")}.pdf`
    }
    await this.feedback.updateLoading("Laden...")
    await PDFGenerator.fromData(document.getElementById("ionContent").innerHTML, options )
    await this.feedback.hideLoading()
  }

  public async saveTicketReport(){
    await this.feedback.updateLoading("Hochladen...")
    let pdfName: string = await this.getTicketReportName()


    const options: PDFGeneratorOptions = {
      documentSize: "A4",
      type: "base64",
      fileName: pdfName 
    }
    let base64: string = ""

    let result: HttpFunctionResult<number> = null
    //If dann nativen Code für Mobile Geräte ausführen
    //Sonst Code für Web ausführen (Ticketreport auf Server erstellen)
    if(this.platform.is("capacitor")) {
      base64 = await PDFGenerator.fromData(document.getElementById("ionContent").innerHTML, options)
      
      const res: Response = await fetch(`data:application/pdf;base64,${base64}`)
      const blob: Blob = await res.blob();
      let pdf: File = new File([blob], pdfName, {type: "application/pdf"})
      
      result = await this.fileSrv.uploadFile(pdf)
      await this.feedback.hideLoading()
    }else{
      result = await this.fileSrv.createTicketReportOnWeb(pdfName, document.getElementById("ionContent").innerHTML)
      await this.feedback.hideLoading()
    }

    if(!result.success) return
    this.ticketSrv.addFile({
      id: result.data,
      description: pdfName,
      type: "Datei"
    })
    await this.modalCtrl.dismiss()
    await this.feedback.showMsg(MsgType.Info, `Der Ticketbericht wurde erfolgreich unter dem Namen "${pdfName}" gespeichert!`)
  }

  /**
   * Gibt einen noch nicht existierenden Namen für einen Ticketbericht zurück
   * @returns 
   */
  private getTicketReportName(): Promise<string>{
    return new Promise(resolve=>{
      const existingReorts: Attachment[] = this.ticketSrv.ticket.attachments.filter(a => a.description.startsWith("ticketbericht_"))
      if(existingReorts.length > 0){
        existingReorts.forEach((a, index)=>{
          const fileNameIndex: string = `_${index + 1}`
          const fileName: string = `ticketbericht_${dayjs().format("DD_MM_YYYY")}${fileNameIndex}.pdf`
          if(!existingReorts.find((a: Attachment) => a.description == fileName)) resolve(fileName)
        })
      } else resolve(`ticketbericht_${dayjs().format("DD_MM_YYYY")}.pdf`)
    })
  }



}
